(function() {
    const widgetSelector = '.reeview-app-widget';
    const slideSelector = '.keen-slider__slide';
    const widgetSelectorDeep = '.ReactModal__Content--after-open';
    const buttonCtaSelector = '.vw-cmp__button-shoppable--primary';


    function attachListeners() {
        const host = document.querySelector(widgetSelector);
        if (!host || !host.shadowRoot) {
            return false;
        }

        const videoCards = host.shadowRoot.querySelectorAll(slideSelector);
        if (!videoCards.length) {
            return false;
        }

        videoCards.forEach((videoCard) => {
            videoCard.addEventListener('click', () => newDomSide());
            videoCard.dataset.gtmListenerAttached = '1';
        });

        return true;
    }

    function init() {
        if (attachListeners()) {
            return;
        }

        const observer = new MutationObserver(() => {
            if (attachListeners()) {
                observer.disconnect();
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }

    let deepListenerAttached = false;
    let colorListenerAttached = false;
    let shareListenerAttached = false;
    let deepButtonInterval = null;

    if (document.readyState === 'loading') {
        window.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    let colorDropdownOpened = false;

    function attachListenersDeep() {
        const hostDeep = document.querySelector(widgetSelectorDeep);
        if (!hostDeep || !hostDeep.shadowRoot) {
            return false;
        }

        const addToCartButton = hostDeep.shadowRoot.querySelector(buttonCtaSelector);
        const colorSelectButton = hostDeep.shadowRoot.querySelector('.vw--color-swatch-dropdown--color');
        const shareButton = hostDeep.shadowRoot.querySelectorAll('.vw-cmp__playerV2--share-button');
        const selectedShareButton = shareButton[1] || shareButton[0];

        if (!addToCartButton || !colorSelectButton || !shareButton.length || !selectedShareButton) {
            return false;
        }

        if (!deepListenerAttached) {
                addToCartButton.addEventListener('click', addTocart);
                // crossellingContainers();
                deepListenerAttached = true;
        }
        
        if (!shareListenerAttached) {
                selectedShareButton.addEventListener('click', shareButtonClick);
                shareListenerAttached = true;
        }

        if (!colorListenerAttached) {
                colorSelectButton.addEventListener('click', addToCartColor);
                clickUGCVideoCard();
                colorListenerAttached = true;
        }

        return true;
    }

    function waitForAddToCartButton() {
        if (deepListenerAttached && colorListenerAttached && shareListenerAttached) {
            return;
        }

        if (deepButtonInterval) {
            return;
        }

        deepButtonInterval = setInterval(() => {
            if (attachListenersDeep()) {
                clearInterval(deepButtonInterval);
                deepButtonInterval = null;
            }
        }, 200);
    }

    function newDomSide() {
        if (attachListenersDeep()) {
            return;
        }

        waitForAddToCartButton();
    }

    function addTocart() {
        const host = document.querySelector(widgetSelectorDeep);
        const videoTitleEl = host.shadowRoot.querySelector('.vw-cmp__shoppable--title');
        const productColorEl = host.shadowRoot.querySelector('.vw--color-swatch-dropdown--color--text');
        const productPriceEl = host.shadowRoot.querySelector('.vw-cmp__shoppable--price');

        if (!videoTitleEl || !productColorEl || !productPriceEl) {
            return;
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'video_card_add_to_cart',
            video_block: 'lifestyle_videos',
            product_name: videoTitleEl.textContent.trim(),
            product_color: productColorEl.textContent.trim(),
            product_price: productPriceEl.textContent.trim()
        });
    }

    function addToCartColor() {
        const host = document.querySelector(widgetSelectorDeep);
        const videoTitleEl = host.shadowRoot.querySelector('.vw-cmp__shoppable--title');
        const productColorEl = host.shadowRoot.querySelector('.vw--color-swatch-dropdown--color--text');
        if (!productColorEl) {
            return;
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'video_card_color_select',
            video_block: 'lifestyle_videos',
            product_name: videoTitleEl.textContent.trim(),
            color_selected: productColorEl.textContent.trim()
        });
    }

    function waitForShareContainer(host) {
        if (!host || !host.shadowRoot) {
            return null;
        }

        const container = host.shadowRoot.querySelectorAll('.vw-cmp__player-modal-share-container-scroll-card');
        const copyLink = host.shadowRoot.querySelector('.vw-cmp__player-modal-share-copy-btn');
        if (container.length) {
            return { container, copyLink };
        }
        return null;
    }

    function shareButtonClick() {
        const host = document.querySelector(widgetSelectorDeep);
        if (!host || !host.shadowRoot) {
            return;
        }

        const maxAttempts = 10;
        let attempts = 0;

        const shareInterval = setInterval(() => {
            attempts += 1;
            const sharableContainer = waitForShareContainer(host);

            if (sharableContainer || attempts >= maxAttempts) {
                clearInterval(shareInterval);
                const sharedMethod = sharableContainer ? 'found' : 'not_found';

                sharableContainer?.copyLink?.addEventListener('click', (e) => {
                    e.preventDefault();
                    if (e.target.closest('.vw-cmp__player-modal-share-copy-btn')) {
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                event: 'video_card_share',
                                video_block: 'lifestyle_videos',
                                shared_method: 'copy_link',
                            });
                        }
                    });

                sharableContainer?.container?.forEach((shareOption) => {
                    shareOption.addEventListener('click', (e) => {
                        e.preventDefault();
                        if (e.target.closest('.vw-cmp__player-modal-share-container-scroll-card')) {
                            const sharedMethod = shareOption.querySelector('.vw-cmp__player-modal-share-container-scroll-card .vw-cmp__player-modal-share-container-scroll-card-text').textContent.trim();
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                event: 'video_card_share',
                                video_block: 'lifestyle_videos',
                                shared_method: sharedMethod,
                            });
                        }
                    });
                })
                
            }
        }, 200);
    }

    // function crossellingContainers() {
    //     console.log('crossellingContainers function called');
    //     const host = document.querySelector(widgetSelectorDeep);
    //     console.log('host', host);
    //     if (!host || !host.shadowRoot) {
    //         return;
    //     }

    //     pollCrossellingContainers(host);
    // }

    // function dataLayerCrosselling(containers) {
    //     const host = document.querySelector(widgetSelectorDeep);
    //     const videoTitleEl = host.shadowRoot.querySelector('.vw-cmp__shoppable--title');
    //     containers.forEach((crossellingContainer) => {
    //         console.log('crossellingContainer', crossellingContainer);
    //         crossellingContainer.addEventListener('click', (e) => {
    //             e.preventDefault();
    //             if (e.target.closest('.vw-cmp__shoppable-list-content-itemV2')) {
    //                 const productName = crossellingContainer.querySelector('.vw-cmp__shoppable-list-content-itemV2--title').textContent.trim();
    //                 window.dataLayer = window.dataLayer || [];
    //                 window.dataLayer.push({
    //                     event: 'video_card_cross_sell_click',
    //                     video_block: 'lifestyle_videos',
    //                     product_name: productName,
    //                     recommended_product: videoTitleEl.textContent.trim()
    //                 });

    //             }
    //         });
    //     });
    // }

    // function pollCrossellingContainers(host) {
    //     const interval = setInterval(() => {
    //         const containers = host.shadowRoot.querySelectorAll('.vw-cmp__recommended-products--grid .vw-cmp__shoppable-list-content-itemV2');
    //         console.log('crossellingContainers', containers);

    //         if (containers.length) {
    //             clearInterval(interval);
    //             console.log('Yes cross-selling containers found');
    //             dataLayerCrosselling(containers);
    //         } else {
    //             console.log('No cross-selling containers found, retrying');
    //         }
    //     }, 200);
    // }

    function clickUGCVideoCard() {
        const host = document.querySelector(widgetSelectorDeep);
        const videoContainer = host.shadowRoot.querySelectorAll('.vw-cmp__playerV2--boxes-wrapper .vw-cmp__playerV2--box');
        if (!videoContainer.length) {
            return;
        }

        videoContainer.forEach((videoCard, index) => {
            videoCard.addEventListener('click', () => {
                const videoTitleEl = host.shadowRoot.querySelector('.vw-cmp__shoppable--title');
                if (!videoTitleEl) {
                    return;
                }
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'video_card_change',
                    video_block: 'lifestyle_videos',
                    video_card_position: index + 1
                });
            });
        });
    }

})();
